/* Модуль личного кабинета, лендинга и виброотклика */
function updateDashboardUI(profile) {
    if (!profile) return;

    // Персонализация заголовка в кабинете
    const titleEl = document.querySelector('.cabinet-title');
    if (titleEl && profile.name) {
      titleEl.innerHTML = `Личный кабинет: <span style="color:#1A8754;">${escapeHTML(profile.name)}</span>`;
    }

    // Плашка подключения Telegram для веб-пользователей
    const bridgeBanner = document.getElementById('webTgBridgeBanner');
    const bridgeLink = document.getElementById('webTgBridgeLink');
    if (bridgeBanner) {
      const isWeb = !profile.telegramId && !window.Telegram?.WebApp?.initData;
      if (isWeb) {
        bridgeBanner.style.display = 'flex';
        if (bridgeLink) {
          const botUser = window.META_BOT_USERNAME || localStorage.getItem('meta_bot_username') || 'meta_institut_bot';
          const linkParam = 'link_' + (profile.id || '');
          const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
          bridgeLink.href = isMobile ? `tg://resolve?domain=${botUser}&start=${linkParam}` : `https://t.me/${botUser}?start=${linkParam}`;
          if (isMobile) bridgeLink.removeAttribute('target');
          bridgeLink.onclick = function(e) {
            if (typeof trackGoal === 'function') trackGoal('web_tg_bridge_click');
            if (typeof openTelegramBot === 'function') {
              e.preventDefault();
              openTelegramBot(linkParam);
            }
          };
        }
      } else {
        bridgeBanner.style.display = 'none';
      }
    }

    // Управление карточкой ключа активации и плашкой успеха закрытого канала
    const isSub = (typeof isChannelSubscribed === 'function' && isChannelSubscribed()) ||
                  localStorage.getItem('meta_channel_subscribed') === 'true' ||
                  (profile && (profile.channel_subscribed === 1 || profile.channel_subscribed === true || profile.channel_subscribed === 'true' || profile.channel_subscribed === '1'));

    const gateCard = document.getElementById('dashboardChannelCard');
    const successCard = document.getElementById('dashboardChannelSuccessCard');
    const botUser = window.META_BOT_USERNAME || localStorage.getItem('meta_bot_username') || 'meta_institut_bot';
    const userId = profile?.id || localStorage.getItem('meta_user_id') || '';
    const startParam = userId ? `auth_${userId}` : 'auth';
    const botAuthUrl = `https://t.me/${botUser}?start=${startParam}`;
    const botDirectUrl = `tg://resolve?domain=${botUser}&start=${startParam}`;

    if (isSub) {
      if (gateCard) gateCard.style.display = 'none';
      if (successCard) successCard.style.display = 'block';
      stopSubscriptionPolling();
    } else {
      if (gateCard) {
        gateCard.style.display = 'block';
        const channelBtn = document.getElementById('dashboardChannelBtn');
        if (channelBtn) {
          const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
          channelBtn.href = isMobile ? botDirectUrl : botAuthUrl;
          if (isMobile) {
            channelBtn.removeAttribute('target');
          }
          channelBtn.onclick = function(e) {
            if (typeof trackGoal === 'function') trackGoal('channel_gate_click');
            startSubscriptionPolling();
            if (typeof openTelegramBot === 'function') {
              e.preventDefault();
              openTelegramBot(startParam);
            }
          };
        }
        const directLink = document.getElementById('dashboardChannelDirectLink');
        if (directLink) {
          directLink.href = botDirectUrl;
          directLink.onclick = function() {
            startSubscriptionPolling();
          };
        }
        const webLink = document.getElementById('dashboardChannelWebLink');
        if (webLink) {
          webLink.href = botAuthUrl;
          webLink.onclick = function() {
            startSubscriptionPolling();
          };
        }
      }
      if (successCard) successCard.style.display = 'none';
      startSubscriptionPolling();
    }
  }

  let _subPollInterval = null;
  let _subPollActive = false;

  function stopSubscriptionPolling() {
    if (_subPollInterval) {
      clearInterval(_subPollInterval);
      _subPollInterval = null;
    }
    _subPollActive = false;
  }

  function startSubscriptionPolling() {
    if (_subPollInterval || _subPollActive) return;
    _subPollActive = true;

    const pollCheck = async () => {
      if (localStorage.getItem('meta_channel_subscribed') === 'true') {
        stopSubscriptionPolling();
        return;
      }

      const u = typeof getUser === 'function' ? getUser() : null;
      const userId = u?.id || localStorage.getItem('meta_user_id');
      const tgId = u?.telegramId || u?.telegram_id || localStorage.getItem('meta_tg_user_id');
      const lookupId = tgId || userId;
      if (!lookupId) return;

      try {
        const res = await fetch(`/api/user/${encodeURIComponent(lookupId)}?t=${Date.now()}`, {
          headers: {
            'X-Telegram-User-Id': tgId ? String(tgId) : ''
          }
        });
        if (!res.ok) return;
        const data = await res.json();
        const user = data.user;
        if (user && (user.channel_subscribed === 1 || user.channel_subscribed === true || user.channel_subscribed === '1' || user.channel_subscribed === 'true')) {
          stopSubscriptionPolling();

          localStorage.setItem('meta_channel_subscribed', 'true');
          localStorage.setItem('meta_unlocked_days', JSON.stringify([1, 2, 3, 4]));
          localStorage.setItem(REGISTERED_FLAG, 'true');

          const activeUser = Object.assign({}, u || {}, user, {
            channel_subscribed: true,
            unlocked_days: [1, 2, 3, 4]
          });
          try {
            localStorage.setItem(STORAGE_KEY, JSON.stringify(activeUser));
            if (activeUser.id) localStorage.setItem('meta_user_id', activeUser.id);
            if (activeUser.telegram_id) localStorage.setItem('meta_tg_user_id', String(activeUser.telegram_id));
          } catch (e) {}

          if (typeof triggerHaptic === 'function') triggerHaptic('success');
          if (typeof showToast === 'function') {
            showToast('🎉 Доступ ко всем 4 урокам открыт!');
          }

          updateDashboardUI(activeUser);
          if (typeof updateDashboardDaysUI === 'function') {
            updateDashboardDaysUI();
          }
          if (typeof updateLandingProgramUI === 'function') {
            updateLandingProgramUI();
          }
        }
      } catch (e) {
        // Фоновая ошибка поллинга игнорируется
      }
    };

    _subPollInterval = setInterval(pollCheck, 3000);
    window.addEventListener('focus', pollCheck);
    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) pollCheck();
    });
  }

  // Обработчик кнопки «🔄 Я уже в канале - обновить доступ»
  async function handleDashboardRefreshAccess() {
    triggerHaptic('medium');
    const btn = document.getElementById('dashboardConfirmChannelBtn');
    const feedback = document.getElementById('dashboardChannelFeedback');
    if (btn) {
      btn.disabled = true;
      btn.innerHTML = '<span class="meta-spinner"></span> Проверяем доступ...';
    }
    if (feedback) feedback.style.display = 'none';

    try {
      const u = typeof getUser === 'function' ? getUser() : null;
      const userId = u?.id || localStorage.getItem('meta_user_id');
      const tgId = u?.telegramId || u?.telegram_id || localStorage.getItem('meta_tg_user_id');
      const tgUser = (u?.username || u?.telegram_username || u?.telegramUsername || localStorage.getItem('meta_tg_username') || '').replace(/^@/, '').trim();
      const phone = u?.phone || localStorage.getItem('meta_phone') || '';

      const res = await fetch('/api/user/channel-subscribe', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          user_id: userId,
          telegram_id: tgId,
          telegram_username: tgUser,
          phone: phone
        })
      });
      const data = await res.json();

      if (data.ok && data.subscribed) {
        localStorage.setItem('meta_channel_subscribed', 'true');
        localStorage.setItem('meta_unlocked_days', JSON.stringify([1, 2, 3, 4]));
        localStorage.setItem(REGISTERED_FLAG, 'true');
        const activeUser = data.user || u || {};
        activeUser.channel_subscribed = true;
        activeUser.unlocked_days = [1, 2, 3, 4];
        try {
          localStorage.setItem(STORAGE_KEY, JSON.stringify(activeUser));
          if (activeUser.id) localStorage.setItem('meta_user_id', activeUser.id);
          if (activeUser.telegram_id) localStorage.setItem('meta_tg_user_id', String(activeUser.telegram_id));
        } catch (e) {}

        triggerHaptic('success');
        if (typeof showToast === 'function') {
          showToast('✓ Доступ ко всем 4 урокам открыт!');
        }
        updateDashboardUI(activeUser);
        if (typeof updateDashboardDaysUI === 'function') {
          updateDashboardDaysUI();
        }
        if (typeof updateLandingProgramUI === 'function') {
          updateLandingProgramUI();
        }
        return;
      }

      if (data.status === 'need_bot_verify' && data.bot_url) {
        if (feedback) {
          feedback.innerHTML = `
            <div style="background: rgba(212, 175, 110, 0.15); border: 1px solid rgba(212, 175, 110, 0.4); border-radius: 12px; padding: 10px; font-size: 12px; color: #260C14; line-height: 1.45;">
              Для подтверждения заявки подтвердите доступ через Telegram-бота:
              <div style="margin-top: 8px;">
                <a href="${data.bot_url}" target="_blank" class="btn-emerald" style="display: block; text-align: center; height: 40px; line-height: 40px; font-size: 13px; text-decoration: none; border-radius: 10px;">
                  Подтвердить через Telegram-бота →
                </a>
              </div>
            </div>
          `;
          feedback.style.display = 'block';
        }
        return;
      }

      if (data.status === 'not_found' || data.status === 'unauthorized') {
        if (feedback) {
          feedback.innerHTML = `
            <div style="background: rgba(220, 53, 69, 0.08); border: 1px solid rgba(220, 53, 69, 0.25); border-radius: 12px; padding: 12px; font-size: 12px; color: #DC3545; line-height: 1.45; text-align: center;">
              <div style="font-weight: 700; margin-bottom: 4px;">Профиль участника не найден в этом браузере</div>
              <div style="color: #5C5857; margin-bottom: 10px; font-size: 11.5px;">Введите ваше имя и Telegram (@username) для входа в кабинет:</div>
              <button type="button" class="btn-emerald" onclick="if (typeof MetaOnboarding !== 'undefined' && MetaOnboarding.openModal) { MetaOnboarding.openModal(); } else if (typeof openModal === 'function') { openModal(); }" style="height: 40px; font-size: 13px; width: 100%; border-radius: 10px;">
                <span>✍️ Войти по Telegram (@username) →</span>
              </button>
            </div>
          `;
          feedback.style.display = 'block';
        }
        return;
      }

      if (feedback) {
        feedback.innerHTML = `
          <div style="background: rgba(220, 53, 69, 0.08); border: 1px solid rgba(220, 53, 69, 0.25); border-radius: 12px; padding: 10px; font-size: 12px; color: #DC3545; line-height: 1.45;">
            ${data.message || 'Заявка еще не обнаружена. Пожалуйста, подайте заявку в закрытый канал по кнопке выше, затем нажмите «Обновить доступ».'}
          </div>
        `;
        feedback.style.display = 'block';
      }
    } catch (err) {
      if (feedback) {
        feedback.innerHTML = `
          <div style="background: rgba(220, 53, 69, 0.08); border: 1px solid rgba(220, 53, 69, 0.25); border-radius: 12px; padding: 10px; font-size: 12px; color: #DC3545;">
            ⚠️ Ошибка связи с сервером. Повторите попытку через пару секунд.
          </div>
        `;
        feedback.style.display = 'block';
      }
    } finally {
      if (btn) {
        btn.disabled = false;
        btn.innerHTML = '<span>🔄 Я уже в канале - обновить доступ</span>';
      }
    }
  }
  window.handleDashboardRefreshAccess = handleDashboardRefreshAccess;


  let dripIntervalId = null;

  function formatTimeRemaining(seconds) {
    const s = Math.max(0, Math.floor(seconds));
    const h = Math.floor(s / 3600);
    const m = Math.floor((s % 3600) / 60);
    const sec = s % 60;
    const pad = n => String(n).padStart(2, '0');
    return `${pad(h)}:${pad(m)}:${pad(sec)}`;
  }

  function getDripSecondsLeft(dayNum) {
    const num = Number(dayNum);
    if (typeof isDayUnlocked === 'function' && isDayUnlocked(num)) return 0;

    const u = (typeof getUser === 'function') ? getUser() : null;
    const regStr = u?.registered_at || u?.createdAt || u?.created_at;

    // 1. Ускоренный drip-доступ: если предыдущий день завершен - считаем время до следующего утра 10:00 МСК
    const prevDay = num - 1;
    const prevCompleted = localStorage.getItem(`meta_day_${prevDay}_completed`) === 'true' ||
      Boolean(u?.completed_days && u.completed_days[prevDay]);
    if (prevCompleted) {
      let completedAt = localStorage.getItem(`meta_day_${prevDay}_completed_at`) ||
        (u?.completed_days && u.completed_days[prevDay]);
      if (!completedAt) {
        completedAt = regStr || new Date().toISOString();
      }
      const targetUnlockMs = typeof window.getNextMorning10MskTimestamp === 'function'
        ? window.getNextMorning10MskTimestamp(completedAt)
        : null;
      if (targetUnlockMs) {
        return Math.max(0, Math.ceil((targetUnlockMs - Date.now()) / 1000));
      }
    }

    // 2. Стандартный расчет drip-доступа от момента регистрации
    const targetOffsets = { 2: 24 * 3600, 3: 48 * 3600, 4: 72 * 3600 };
    if (!regStr) return targetOffsets[num] || 0;
    const regTime = new Date(regStr).getTime();
    if (isNaN(regTime)) return targetOffsets[num] || 0;

    const requiredSeconds = targetOffsets[num] || 0;
    const elapsedSeconds = (Date.now() - regTime) / 1000;
    return Math.max(0, requiredSeconds - elapsedSeconds);
  }

  function startDripCountdowns() {
    if (dripIntervalId) {
      clearInterval(dripIntervalId);
      dripIntervalId = null;
    }

    function tick() {
      let anyActive = false;
      const isReg = typeof isRegistered === 'function' ? isRegistered() : false;
      const u = typeof getUser === 'function' ? getUser() : null;
      const regStr = u?.registered_at || u?.createdAt || u?.created_at;

      [2, 3, 4].forEach(d => {
        const isUnlocked = typeof isDayUnlocked === 'function' ? isDayUnlocked(d) : false;
        const tagEl = document.getElementById(`day${d}TimerTag`);
        const liveLockEl = document.getElementById(`day${d}LiveLockTimer`);
        const cdEl = document.getElementById(`day${d}CountdownTimer`);

        if (isUnlocked) {
          if (tagEl) tagEl.textContent = '✓ УРОК ДОСТУПЕН';
          if (liveLockEl) liveLockEl.textContent = '✓ УРОК ДОСТУПЕН';
          if (cdEl) cdEl.textContent = '✓ УРОК ДОСТУПЕН';
          return;
        }

        // Если не зарегистрирован или нет времени регистрации - таймер не разблокирует урок автоматически
        if (!isReg || !regStr) {
          const defaultTimes = { 2: '24:00:00', 3: '48:00:00', 4: '72:00:00' };
          if (tagEl) tagEl.textContent = `⏳ Откроется через ${defaultTimes[d]}`;
          if (liveLockEl) liveLockEl.textContent = `🔒 Доступно после регистрации`;
          if (cdEl) cdEl.textContent = `⏳ Откроется через ${defaultTimes[d]}`;
          return;
        }

        const prevDay = d - 1;
        const prevCompleted = localStorage.getItem(`meta_day_${prevDay}_completed`) === 'true' ||
          Boolean(u?.completed_days && u.completed_days[prevDay]);

        const secLeft = getDripSecondsLeft(d);
        if (secLeft > 0) {
          anyActive = true;
          const formatted = formatTimeRemaining(secLeft);
          let slotLabel = 'завтра в 10:00 МСК';
          if (prevCompleted) {
            let completedAt = localStorage.getItem(`meta_day_${prevDay}_completed_at`) ||
              (u?.completed_days && u.completed_days[prevDay]);
            if (typeof window.getDripSlotLabel === 'function') {
              slotLabel = window.getDripSlotLabel(completedAt);
            }
          }
          const prefix = prevCompleted ? `⏳ Откроется ${slotLabel}` : '⏳ Откроется через';
          if (tagEl) tagEl.textContent = `${prefix} (${formatted})`;
          if (liveLockEl) liveLockEl.textContent = `${prefix} (${formatted})`;
          if (cdEl) cdEl.textContent = `${prefix} (${formatted})`;
        } else {
          // Время действительно вышло для зарегистрированного пользователя:
          if (typeof unlockDayLocally === 'function') unlockDayLocally(d);
          if (typeof updateDayPageUI === 'function') updateDayPageUI();
          updateDashboardDaysUI();
          if (tagEl) tagEl.textContent = '✓ УРОК ДОСТУПЕН';
          if (liveLockEl) liveLockEl.textContent = '✓ УРОК ДОСТУПЕН';
          if (cdEl) cdEl.textContent = '✓ УРОК ДОСТУПЕН';
        }
      });
      if (!anyActive && dripIntervalId) {
        clearInterval(dripIntervalId);
        dripIntervalId = null;
      }
    }

    tick();
    dripIntervalId = setInterval(tick, 1000);
  }

  function handleDayCardClick(event, dayNum, targetUrl) {
    const isUnlocked = typeof isDayUnlocked === 'function' ? isDayUnlocked(dayNum) : false;
    if (isUnlocked) {
      if (typeof triggerHaptic === 'function') triggerHaptic('light');
      if (typeof window.handleTicketClick === 'function') {
        return window.handleTicketClick(event, targetUrl || `/day-${dayNum}.html`);
      }
      return true;
    }
    if (event) event.preventDefault();
    if (typeof triggerHaptic === 'function') triggerHaptic('warning');

    const isSub = (typeof isChannelSubscribed === 'function' && isChannelSubscribed()) ||
                  localStorage.getItem('meta_channel_subscribed') === 'true';

    const gateCard = document.getElementById('dashboardChannelCard');
    if (!isSub && gateCard && gateCard.style.display !== 'none') {
      gateCard.scrollIntoView({ behavior: 'smooth' });
      if (typeof showToast === 'function') {
        showToast('🔒 Подтвердите доступ в Telegram-канале выше');
      }
    } else {
      if (typeof showToast === 'function') {
        showToast(`⏳ Урок ${dayNum} откроется по расписанию`);
      }
    }
    return false;
  }
  window.handleDayCardClick = handleDayCardClick;

  function updateDashboardDaysUI() {
    const isDashboard = window.location.pathname.includes('dashboard') || Boolean(document.querySelector('.days-stack'));
    if (!isDashboard) return;

    // 1. Управление статусами и внешним видом 3-частных карточек Дней 1, 2, 3, 4
    [1, 2, 3, 4].forEach(function(d) {
      const unlocked = typeof isDayUnlocked === 'function' ? isDayUnlocked(d) : false;
      const isCompleted = localStorage.getItem(`meta_day_${d}_completed`) === 'true';
      const card = document.getElementById('dayCard' + d);
      if (!card) return;

      const numBadge = document.getElementById(`day${d}NumBadge`);
      const statusBadge = document.getElementById(`day${d}StatusBadge`);
      const actionCircle = document.getElementById(`day${d}ActionCircle`);
      const tagEl = document.getElementById(`day${d}TimerTag`);

      if (isCompleted) {
        card.classList.add('completed', 'unlocked');
        card.classList.remove('locked');
        if (numBadge) numBadge.innerHTML = '✓';
        if (statusBadge) {
          statusBadge.className = 'badge-available';
          statusBadge.textContent = '✓ Пройдено';
          statusBadge.style.background = 'rgba(34, 169, 107, 0.15)';
        }
        if (actionCircle) {
          actionCircle.classList.remove('animate-pulse-gold');
          actionCircle.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>';
        }
        if (tagEl) tagEl.textContent = '✓ Пройдено';
      } else if (unlocked) {
        card.classList.add('unlocked');
        card.classList.remove('locked', 'completed');
        if (numBadge) numBadge.textContent = String(d);
        if (statusBadge) {
          statusBadge.className = 'badge-available';
          statusBadge.textContent = '✓ Доступно';
          statusBadge.style.background = '';
        }
        if (actionCircle) {
          actionCircle.classList.add('animate-pulse-gold');
          actionCircle.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" stroke="none"><polygon points="6 3 20 12 6 21 6 3"/></svg>';
        }
        if (tagEl) tagEl.textContent = '✓ Урок доступен';
      } else {
        card.classList.add('locked');
        card.classList.remove('unlocked', 'completed');
        if (numBadge) numBadge.textContent = String(d);
        if (statusBadge) {
          statusBadge.className = 'badge-locked';
          statusBadge.textContent = '🔒 Закрыто';
          statusBadge.style.background = '';
        }
        if (actionCircle) {
          actionCircle.classList.remove('animate-pulse-gold');
          actionCircle.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><rect width="18" height="11" x="3" y="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>';
        }
      }

      // Совместимость со старым футером карточки, если присутствует в DOM
      const footer = card.querySelector('.day-card-footer');
      if (footer) {
        if (unlocked) {
          const actionText = (d === 4) ? 'Смотреть финал →' : 'Смотреть урок →';
          footer.innerHTML = `
            <span class="day-time-tag" style="background: rgba(34, 169, 107, 0.12); color: #15803D; font-weight: 700;">${isCompleted ? '✓ ПРОЙДЕНО' : '✓ УРОК ДОСТУПЕН'}</span>
            <a href="/day-${d}.html" class="day-action-link" style="color: #15803D; font-weight: 800;" onclick="if (typeof window.handleTicketClick === 'function') { return window.handleTicketClick(event, '/day-${d}.html'); }">
              <span>${actionText}</span>
            </a>
          `;
        } else {
          footer.innerHTML = `
            <span class="day-time-tag" style="background: rgba(220, 53, 69, 0.08); color: #DC3545; font-weight: 700;">🔒 ЗАКРЫТО</span>
            <span class="day-action-link" style="color: #9C7A41; font-weight: 700; cursor: pointer;" onclick="document.getElementById('dashboardChannelCard')?.scrollIntoView({behavior: 'smooth'})">
              <span>🔑 Активировать вверху ↑</span>
            </span>
          `;
        }
      }
    });

    // Карточка спецусловий курса в кабинете
    const tariffsCard = document.getElementById('dashboardCourseTariffsCard');
    if (tariffsCard) {
      tariffsCard.style.display = 'block';
    }

    updateBottomNavForDay4();
    startDripCountdowns();
  }
  window.updateDashboardDaysUI = updateDashboardDaysUI;

  // Переключение 3-й вкладки нижнего бара меню на «Тарифы» для участников 4-го дня
  function updateBottomNavForDay4() {
    const isD4 = (typeof isDayUnlocked === 'function' ? isDayUnlocked(4) : false) || 
                 localStorage.getItem('meta_day_4_completed') === 'true';
    const tab3 = document.getElementById('bottomNavTab3') || document.querySelector('.bottom-nav-item:nth-child(3)');
    if (!tab3) return;

    const currentPath = window.location.pathname;
    const isTariffsPage = currentPath.includes('course-tariffs');
    const isQuestionnaire = currentPath.includes('questionnaire');

    if (isD4) {
      tab3.href = '/course-tariffs.html';
      tab3.innerHTML = `
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="${isTariffsPage ? 'currentColor' : 'none'}" stroke="${isTariffsPage ? 'none' : 'currentColor'}" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 10v6M2 10l10-5 10 5-10 5z"/><path d="M6 12v5c3 3 9 3 12 0v-5"/></svg>
        <span>Тарифы</span>
      `;
      if (isTariffsPage) {
        document.querySelectorAll('.bottom-nav-item').forEach(el => el.classList.remove('active'));
        tab3.classList.add('active');
      }
    } else {
      tab3.href = '/questionnaire.html';
      tab3.innerHTML = `
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="${isQuestionnaire ? 'currentColor' : 'none'}" stroke="${isQuestionnaire ? 'none' : 'currentColor'}" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><line x1="16" y1="13" x2="8" y2="13"></line><line x1="16" y1="17" x2="8" y2="17"></line><polyline points="10 9 9 9 8 9"></polyline></svg>
        <span>Анкета</span>
      `;
      if (isQuestionnaire) {
        document.querySelectorAll('.bottom-nav-item').forEach(el => el.classList.remove('active'));
        tab3.classList.add('active');
      }
    }
  }

  // Фиксация активности по тарифам курса в user_activity_logs
  function trackCourseAction(eventType, details = {}) {
    try {
      const u = (typeof getUser === 'function' ? getUser() : {}) || {};
      return fetch('/api/activity/track', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          user_id: u.id || '',
          telegram_id: u.telegramId || '',
          event_type: eventType,
          day_number: 4,
          details: {
            ...details,
            target_url: 'https://astrology-temple.getcourse.ru/Metainstitut',
            timestamp: new Date().toISOString()
          }
        })
      }).catch(() => {});
    } catch (e) {
      return Promise.resolve();
    }
  }

  // Открытие выбранного тарифа на GetCourse с тактильным откликом и трекингом
  function openCourseTariff(tariffId, tariffName, price) {
    triggerHaptic('success');
    trackCourseAction('tariff_clicked', {
      tariff: tariffName || tariffId,
      tariff_id: tariffId,
      price: price || '',
      source: window.location.pathname
    });

    const targetUrl = 'https://astrology-temple.getcourse.ru/Metainstitut';
    const tg = window.Telegram?.WebApp;
    if (tg && typeof tg.openLink === 'function') {
      tg.openLink(targetUrl);
    } else {
      window.open(targetUrl, '_blank');
    }
  }

  // Обработчик кнопки "Смотреть День 1 / Войти в кабинет"
  async function handleTicketClick(e, explicitTarget = null) {
    if (e) {
      if (typeof e.preventDefault === 'function') e.preventDefault();
      if (typeof e.stopPropagation === 'function') e.stopPropagation();
    }
    triggerHaptic('light');

    const currentSearch = window.location.search || '';
    const targetDashboardUrl = (explicitTarget || '/dashboard.html') + currentSearch;

    if (!isRegistered()) {
      if (typeof trackGoal === 'function') {
        trackGoal('open_lead_modal');
      }
      if (typeof openModal === 'function') {
        openModal(targetDashboardUrl);
      } else if (typeof window.openModal === 'function') {
        window.openModal(targetDashboardUrl);
      }
      return false;
    }

    if (typeof trackGoal === 'function') {
      trackGoal('cabinet_click');
    }

    // Переход в личный кабинет со всеми днями интенсива
    if (typeof spaNavigate === 'function') {
      spaNavigate(targetDashboardUrl);
    } else {
      window.location.href = targetDashboardUrl;
    }
    return false;
  }
  window.handleTicketClick = handleTicketClick;

  function openTelegramBotWithFallback(startParam) {
    if (typeof trackGoal === 'function') {
      trackGoal('hero_tg_click');
    }
    const botUser = window.META_BOT_USERNAME || localStorage.getItem('meta_bot_username') || 'meta_institut_bot';
    const urlParams = new URLSearchParams(window.location.search);
    const param = startParam || urlParams.get('start') || urlParams.get('utm_campaign') || 'landing_gateway';
    
    // Прямой переход в WebApp внутри Telegram
    const tgDirectUrl = `https://t.me/${botUser}/meta?startapp=${encodeURIComponent(param)}`;
    const tgAppUrl = `tg://resolve?domain=${encodeURIComponent(botUser)}&appname=meta&startapp=${encodeURIComponent(param)}`;

    const startTime = Date.now();
    window.location.href = tgAppUrl;

    setTimeout(() => {
      if (!document.hidden && (Date.now() - startTime) < 2500) {
        // Пробуем универсальную веб-ссылку t.me/meta_institut_bot/meta
        window.location.href = tgDirectUrl;
      }
    }, 1200);
  }
  window.openTelegramBotWithFallback = openTelegramBotWithFallback;

  // Стартовый шлюз выбора: Telegram vs Веб перед главной страницей
  function initEntryGateway() {
    const gateway = document.getElementById('metaWelcomeGateway');
    if (!gateway) return;

    const isTg = Boolean(window.Telegram?.WebApp?.initData);
    if (isTg || isRegistered()) {
      gateway.style.display = 'none';
      document.body.classList.remove('meta-gateway-active');
      return;
    }

    const choice = sessionStorage.getItem('meta_gateway_choice');
    if (choice === 'web') {
      gateway.style.display = 'none';
      document.body.classList.remove('meta-gateway-active');
      return;
    }

    gateway.style.display = 'flex';
    document.body.classList.add('meta-gateway-active');
  }

  function chooseGatewayWeb() {
    if (typeof trackGoal === 'function') {
      trackGoal('gateway_choice_web');
    }
    sessionStorage.setItem('meta_gateway_choice', 'web');
    const gateway = document.getElementById('metaWelcomeGateway');
    if (gateway) {
      gateway.classList.add('meta-gateway-closing');
      setTimeout(() => {
        gateway.style.display = 'none';
        gateway.classList.remove('meta-gateway-closing');
        document.body.classList.remove('meta-gateway-active');
      }, 250);
    }
  }
  window.chooseGatewayWeb = chooseGatewayWeb;

  function openGatewayTelegram() {
    if (typeof trackGoal === 'function') {
      trackGoal('gateway_choice_tg');
    }
    openTelegramBotWithFallback();
  }
  window.openGatewayTelegram = openGatewayTelegram;

  // Обновление кнопок лендинга и навигации (динамический CTA)
  function updateLandingCTA() {
    const registered = isRegistered();

    // 1. Скрытие/показ нижней панели навигации для незарегистрированных пользователей
    const bottomNav = document.querySelector('.bottom-nav-bar');
    const isHome = window.location.pathname === '/' || 
                   window.location.pathname.endsWith('index.html') || 
                   window.location.pathname.endsWith('landing.html') ||
                   window.location.pathname.endsWith('landing') ||
                   window.location.pathname === '';

    if (bottomNav) {
      if (isHome) {
        bottomNav.style.display = registered ? 'flex' : 'none';
      } else {
        bottomNav.style.display = 'flex';
      }
    }

    // ВАЖНО: Если мы НЕ на главной/лендинге — выходим!
    const isDashboardPage = Boolean(document.querySelector('.cabinet-title, .days-stack, #dashboardShareBtn')) || window.location.pathname.includes('dashboard');
    const isReferralPage = Boolean(document.querySelector('#refLinkText, #invitedFriendsList, #refFriendsCountBadge')) || window.location.pathname.includes('referral');
    const isDayPage = Boolean(document.querySelector('.day-header, .btn-video-player, #liveBroadcastBtn, .day-top-bar, #markCompletedBtn, .btn-complete-block')) || window.location.pathname.includes('day-');
    if (!isHome || isDashboardPage || isReferralPage || isDayPage) return;

    // Инициализация шлюза выбора для внешнего веб-трафика
    initEntryGateway();

    // 2. Управление карточкой участника Smart Participant Card и кнопками входа
    const welcomeCard = document.getElementById('participantWelcomeCard');
    const heroNewcomerBtn = document.getElementById('heroNewcomerBtn');
    const heroWebDualCta = document.getElementById('heroWebDualCta');
    const tgFallbackBanner = document.getElementById('tgFallbackBanner');

    const searchParams = new URLSearchParams(window.location.search);
    if (tgFallbackBanner && searchParams.get('fallback') === 'tg') {
      tgFallbackBanner.style.display = 'flex';
    }

    const isTgMiniApp = Boolean(window.Telegram?.WebApp?.initData);

    if (registered) {
      if (heroNewcomerBtn) heroNewcomerBtn.style.display = 'none';
      if (heroWebDualCta) heroWebDualCta.style.display = 'none';
      if (welcomeCard) {
        welcomeCard.style.display = 'block';
        const user = getUser() || {};
        const nameEl = document.getElementById('participantWelcomeName');
        if (nameEl) nameEl.textContent = user.name || 'С возвращением!';
        
        const daysEl = document.getElementById('participantWelcomeDays');
        if (daysEl) daysEl.textContent = `${getUnlockedDays().length} из 4`;
        
        const friendsEl = document.getElementById('participantWelcomeFriends');
        if (friendsEl) friendsEl.textContent = String(getReferralCount());
      }
    } else {
      if (welcomeCard) welcomeCard.style.display = 'none';
      if (heroNewcomerBtn) heroNewcomerBtn.style.display = '';
      if (heroWebDualCta) heroWebDualCta.style.display = 'none';
    }

    // 3. Смена текста и ссылки CTA-кнопок на лендинге
    document.querySelectorAll('.btn-emerald, .btn-main').forEach(btn => {
      if (btn.closest('.meta-onboard-card, .meta-pay-card, .meta-quest-card, .meta-bonus-modal-card, .btn-complete-block, .meta-gateway-card')) return;
      if (btn.id === 'markCompletedBtn') return;
      if (btn.id === 'dashboardShareBtn' || btn.id === 'referralShareBtn') return;
      if (btn.getAttribute('onclick')?.includes('shareInvite') || btn.getAttribute('onclick')?.includes('toggleCompleted')) return;
      if (btn.closest('.progress-card, .link-field-box, .stat-tile, .broadcast-card, .inline-video-card')) return;

      const currentSearch = window.location.search || '';
      const targetDashboardUrl = '/dashboard.html' + currentSearch;

      // Все кнопки лендинга ведут в Личный кабинет
      if (registered) {
        btn.setAttribute('href', targetDashboardUrl);
        btn.innerHTML = '<span>Войти в личный кабинет</span> <span>→</span>';
        btn.onclick = function(e) { return handleTicketClick(e); };
      } else {
        const targetDay1Url = '/day-1.html' + currentSearch;
        btn.setAttribute('href', targetDay1Url);
        btn.innerHTML = '<span>👉 Начать смотреть 1-ю лекцию бесплатно</span> <span>→</span>';
        btn.onclick = function(e) { return handleTicketClick(e, '/day-1.html'); };
      }
    });

    // 4. Подписи под кнопками
    document.querySelectorAll('.cta-subtext').forEach(el => {
      if (registered) {
        el.innerHTML = '<span style="color:#1A8754; font-weight:600;">✅ Вы успешно зарегистрированы.</span> Нажмите, чтобы войти в кабинет.';
      } else {
        el.textContent = 'Бесплатный билет • Доступ в личный кабинет ко всем 4 урокам';
      }
    });

    // 5. Динамическое обновление бейджей программы марафона на лендинге
    updateLandingProgramUI();
  }

  // Динамическая синхронизация программы марафона на лендинге с Telegram-каналом
  function updateLandingProgramUI() {
    const isProgramPresent = Boolean(document.querySelector('.program-stack') || document.getElementById('landingProgramCard1'));
    if (!isProgramPresent) return;

    const u = (typeof getUser === 'function') ? getUser() : null;
    const isSub = (typeof isChannelSubscribed === 'function' && isChannelSubscribed()) ||
                  localStorage.getItem('meta_channel_subscribed') === 'true' ||
                  Boolean(u && (u.channel_subscribed === 1 || u.channel_subscribed === true || u.channel_subscribed === 'true' || u.channel_subscribed === '1')) ||
                  Boolean(u && (u.has_paid || u.hasPaid)) ||
                  localStorage.getItem('meta_paid_all_days') === 'true';

    [1, 2, 3, 4].forEach(function(d) {
      const card = document.getElementById('landingProgramCard' + d);
      const label = document.getElementById('landingProgramLabel' + d);
      const badge = document.getElementById('landingProgramBadge' + d);

      if (isSub) {
        if (card) {
          card.classList.add('unlocked');
        }
        if (badge) {
          badge.className = 'badge-available';
          badge.textContent = '✓ Доступно';
        }
        if (label) {
          const icon = (d === 4) ? '🔥' : '🟢';
          const title = (d === 4) ? 'День 4 • Финал' : `День ${d} • Урок ${d}`;
          label.innerHTML = `${icon} ${title}`;
        }
      } else {
        if (card) {
          card.classList.remove('unlocked');
        }
        if (badge) {
          badge.className = 'badge-locked';
          badge.textContent = '🔒 Закрыто';
        }
        if (label) {
          const title = (d === 4) ? 'День 4 • Финал' : `День ${d} • Урок ${d}`;
          label.innerHTML = `🔒 ${title}`;
        }
      }
    });
  }
  window.updateLandingProgramUI = updateLandingProgramUI;

  // Проверка параметров успешной оплаты GetCourse в startapp
  function checkStartParamPayment() {
    const src = getSourceParam();
    if (!src) return;

    if (src.includes('paid_all') || src.includes('paid_day')) {
      // Показываем заглушку проверки платежа
      const modalHtml = `
        <div class="meta-celebrate-backdrop is-open" id="metaPaymentWaitModal" style="z-index: 9999;">
          <div class="meta-celebrate-card" role="dialog" aria-modal="true">
            <div style="font-size: 42px; margin-bottom: 12px; animation: pulse 1.5s infinite;">⏳</div>
            <h2 style="font-family: 'Cinzel', Georgia, serif; font-size: 19px; font-weight: 800; margin: 8px 0 6px; line-height: 1.3;">
              Оплата проверяется...
            </h2>
            <p style="font-size: 13px; color: #5C5857; line-height: 1.5; margin-bottom: 20px;">
              Пожалуйста, подождите несколько секунд, пока мы синхронизируем данные с сервером.
            </p>
          </div>
        </div>
        <style>@keyframes pulse { 0% { opacity: 1; transform: scale(1); } 50% { opacity: 0.6; transform: scale(1.1); } 100% { opacity: 1; transform: scale(1); } }</style>
      `;
      document.body.insertAdjacentHTML('beforeend', modalHtml);

      // Полностью полагаемся на серверный вебхук и синхронизацию профиля.
      setTimeout(async () => {
        await syncProfileWithServer(); // Форсируем синхронизацию
        const modal = document.getElementById('metaPaymentWaitModal');
        if (modal) modal.remove();
        
        const days = JSON.parse(localStorage.getItem('meta_unlocked_days') || '[]');
        const isDash = window.location.pathname.includes('dashboard');
        if (days.length > 0 && isDash) {
           if (src.includes('paid_all') && days.includes(4)) showCelebrationModal(4, false);
           else if (src.includes('paid_day2') && days.includes(2)) showCelebrationModal(2, false);
           else if (src.includes('paid_day3') && days.includes(3)) showCelebrationModal(3, false);
           else if (src.includes('paid_day4') && days.includes(4)) showCelebrationModal(4, false);
        }
      }, 3500);
    }
  }

  // Управление видимостью кнопки "Личный кабинет" в шапке лендинга (если присутствует)
  function updateHeaderNav() {
    const cabinetLinks = document.querySelectorAll('.cabinet-link');
    const isReg = isRegistered();
    cabinetLinks.forEach(link => {
      link.style.display = isReg ? 'inline-flex' : 'none';
    });
  }

  // Нативная кнопка "Назад" в Telegram WebApp
  let telegramBackBound = false;
  function updateTelegramBackButton(optionalPath) {
    if (!window.Telegram?.WebApp?.BackButton) return;
    const path = optionalPath || window.location.pathname;
    const isRootOrDashboard = path === '/' || 
                             path.endsWith('index.html') || 
                             path.endsWith('landing.html') || 
                             path.endsWith('dashboard.html') || 
                             path.endsWith('dashboard') ||
                             path === '';

    if (isRootOrDashboard) {
      try { window.Telegram.WebApp.BackButton.hide(); } catch (e) {}
    } else {
      try {
        window.Telegram.WebApp.BackButton.show();
        if (!telegramBackBound) {
          window.Telegram.WebApp.BackButton.onClick(handleTelegramBackClick);
          telegramBackBound = true;
        }
      } catch (e) {}
    }
  }

  function handleTelegramBackClick() {
    try { triggerHaptic('light'); } catch (e) {}
    const target = isRegistered() ? '/dashboard.html' : '/landing.html';
    if (typeof spaNavigate === 'function') {
      spaNavigate(target);
    } else {
      window.location.href = target;
    }
  }

  // Применение настроек ссылок из админ-панели
  function applyAdminSettings(optionalPath) {
    try {
      const tgChannelUrl = getChannelUrl();
      document.querySelectorAll('a.btn-tg-channel').forEach(a => {
        a.href = tgChannelUrl;
      });

      const raw = localStorage.getItem('meta_marathon_settings');
      if (!raw) return;
      const settings = JSON.parse(raw);
      
      const currentPath = optionalPath || window.location.pathname;
      const day1Url = settings.day1_zoom || settings.day1_record || settings.day1_url;
      const day2Url = settings.day2_zoom || settings.day2_record || settings.day2_url;
      const day3Url = settings.day3_zoom || settings.day3_record || settings.day3_url;
      const day4Url = settings.day4_zoom || settings.day4_record || settings.day4_url;

      if (currentPath.includes('day-1') && day1Url) {
        document.querySelectorAll('a[href*="zoom.us"], #day1InlineVideo').forEach(el => {
          if (el.tagName === 'VIDEO') el.src = day1Url;
          else if (el.tagName === 'A') el.href = day1Url;
        });
      }
      if (currentPath.includes('day-2') && day2Url) {
        const vid = document.getElementById('day2InlineVideo');
        if (vid && !vid.src) vid.src = day2Url;
        document.querySelectorAll('#day2BroadcastBtn, .broadcast-card .btn-emerald').forEach(el => {
          if (el.tagName === 'A') el.href = day2Url;
        });
      }
      if (currentPath.includes('day-3') && day3Url) {
        const vid = document.getElementById('day3InlineVideo');
        if (vid && !vid.src) vid.src = day3Url;
        document.querySelectorAll('#day3BroadcastBtn, .broadcast-card .btn-emerald').forEach(el => {
          if (el.tagName === 'A') el.href = day3Url;
        });
      }
      if (currentPath.includes('day-4') && day4Url) {
        const vid = document.getElementById('day4InlineVideo');
        if (vid && !vid.src) vid.src = day4Url;
        document.querySelectorAll('#day4BroadcastBtn, .broadcast-card .btn-emerald').forEach(el => {
          if (el.tagName === 'A') el.href = day4Url;
        });
      }
      if (settings.channel_url) {
        try { localStorage.setItem('meta_channel_url', settings.channel_url); } catch (e) {}
        document.querySelectorAll('a[href*="astrology_temple_private"], a.btn-tg-channel, #dashboardChannelBtn').forEach(a => a.href = settings.channel_url);
      }
      if (settings.support_url) {
        document.querySelectorAll('a.support-chat-link').forEach(a => a.href = settings.support_url);
      }
    } catch (e) {}
  }

  // Секретный жест для входа в админ-панель (5 быстрых кликов по логотипу)
  function initAdminSecretGesture() {
    const logos = document.querySelectorAll('.brand-logo-circle, .day-icon-hero, .day-icon-circle');
    let clickCount = 0;
    let timer = null;

    logos.forEach(logo => {
      logo.addEventListener('click', (e) => {
        clickCount++;
        clearTimeout(timer);
        timer = setTimeout(() => { clickCount = 0; }, 2500);

        if (clickCount >= 5) {
          clickCount = 0;
          if (confirm('🔐 Открыть панель администратора?')) {
            window.location.href = '/admin.html';
          }
        }
      });
    });
  }


  // Scroll Lock & BackButton синхронизация для модальных окон
  function updateModalScrollLock() {
    const hasOpenModal = document.querySelector('[class*="-backdrop"].is-open');
    if (hasOpenModal) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
  }

  function closeAnyOpenModal() {
    if (typeof closeModal === 'function') closeModal();
    if (typeof closeQuestionnaireModal === 'function') closeQuestionnaireModal();
    if (typeof closePayModal === 'function') closePayModal();
    if (typeof closeVideoPlayer === 'function') closeVideoPlayer();
    if (typeof closeRecordWait === 'function') closeRecordWait();
    if (typeof closeLiveBroadcastWait === 'function') closeLiveBroadcastWait();
    if (typeof closeBonusModal === 'function') closeBonusModal();
    const cel = document.getElementById('metaCelebrateBackdrop');
    if (cel) cel.remove();
    const payWait = document.getElementById('metaPaymentWaitModal');
    if (payWait) payWait.remove();
  }

  function onModalStateChanged() {
    updateModalScrollLock();
    initTelegramBackButton();
  }

  let tgBackHandler = null;

  // Нативная кнопка "Назад" в Telegram WebApp